<template>
    <div
        class="list-item-container"
        data-cy="listItemContainer"
    >
        <div
            class="list-item row ml-0 mr-0"
            data-cy="listItem"
        >
            <div
                v-for="column in columns"
                :key="column.key"
                :class="['list-column', column.class, {'ml-auto': column.key === 'options'}]"
                :data-cy="camelCase(`listColumn ${column.key}`)"
            >
                <slot
                    :name="`cell(${camelCase(column.key)})`"
                    :item="item"
                >
                    <template v-if="item.hasOwnProperty(column.key) && !column.value">
                        {{ item[column.key] }}
                    </template>

                    <template v-else-if="column.value">
                        {{ column.value(item) }}
                    </template>

                    <template v-else-if="column.component">
                        <component
                            :is="column.component"
                            :name="column.key"
                            :item="item"
                            :options="column.options"
                            data-cy="listItemComponent"
                        />
                    </template>

                    <template v-else-if="column.key === 'options'">
                        <!-- Displayed when column has a key of options -->
                        <slot name="list-item-action-buttons" />
                    </template>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    import camelCase from 'lodash/camelCase';

    /**
     * @group List View Components
     */
    export default {
        name: 'LListItem',
        props: {
            // Array of objects that define what the column should display.
            // i.e.<br /><br />`{ key: '<key of thing to display on item>',
            // class: 'classes to add to column',
            // sortable: boolean,
            // sortBy: 'actual key to sort by',
            // component: ComponentName, options: {}, value() { return 'a calculated callback function'; } }`<br/><br />
            // *A special key of `options` will display the `list-item-action-buttons` slot contents.
            // If you provide a key that doesn't exist, you can either set a `value()` callback function
            // that returns a string to display or set `component` to a component that you'd like displayed and it will use it.
            columns: {
                type: Array,
                required: true
            },
            // Interacts with passed columns to display fields.
            item: {
                type: Object,
                required: true
            },
        },
        methods: {
            camelCase,
        },
    };
</script>

<style
    lang="sass"
    scoped
>
    .row
        > *
            padding: 0.75rem
            line-height: 2rem

    .btn-link
        padding: 0
        margin-top: -0.25rem

    .options
        flex-grow: 0
        padding: 0.75rem
        text-align: right
        margin-left: -0.5rem
        overflow: hidden
        display: flex
        flex-direction: row
        justify-content: flex-end
        align-items: center

        .btn
            &.btn-link
                min-width: unset

                &:visited
                    color: var(--kc-blue-500) !important

                    &:hover
                        color: var(--kc-blue-600) !important

    .list-item-container
        display: flex
        flex-direction: column
        width: 100%
        border-bottom: 1px solid var(--kc-gray-100)

    .list-item
        display: flex
        flex-direction: row
        flex-wrap: nowrap

    body.mode.dark
        .list-item-container
            border-bottom-color: var(--kc-blue-700)

            .fa,
            .far,
            .fas,
            .btn-link
                color: var(--kc-blue-400)

                &:hover
                    color: var(--kc-blue-300)
</style>
